import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DetailPage from '@shell/components/Resource/Detail/Page.vue';
import { CONFIG_MAP } from '@shell/config/types';
import ResourceTabs from '@shell/components/form/ResourceTabs/index.vue';
import ConfigMapDataTab from '@shell/components/Resource/Detail/ResourceTabs/ConfigMapDataTab/index.vue';
import { useGetConfigMapDataTabProps } from '@shell/components/Resource/Detail/ResourceTabs/ConfigMapDataTab/composables';
import { useStore } from 'vuex';
import { computed } from 'vue';
import Masthead from '@shell/components/Resource/Detail/Masthead/index.vue';
import { useDefaultMastheadProps } from '@shell/components/Resource/Detail/Masthead/composable';


export default /*@__PURE__*/_defineComponent({
  __name: 'configmap',
  props: {
    value: {}
  },
  setup(__props: any) {

const store = useStore();
const props = __props;

const configmap = props.value;
const schema = computed(() => store.getters['cluster/schemaFor'](CONFIG_MAP));
const defaultMastheadProps = useDefaultMastheadProps(configmap);
const configMapDataTabProps = useGetConfigMapDataTabProps(configmap);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DetailPage, null, {
    "top-area": _withCtx(() => [
      _createVNode(Masthead, _normalizeProps(_guardReactiveProps(_unref(defaultMastheadProps))), null, 16)
    ]),
    "bottom-area": _withCtx(() => [
      _createVNode(ResourceTabs, {
        value: _unref(configmap),
        schema: schema.value
      }, {
        default: _withCtx(() => [
          _createVNode(ConfigMapDataTab, _normalizeProps(_guardReactiveProps(_unref(configMapDataTabProps))), null, 16)
        ]),
        _: 1
      }, 8, ["value", "schema"])
    ]),
    _: 1,
    __: [0]
  }))
}
}

})